import React from 'react';
import { toLocalizedFormat } from '@dutchinvoice/shared-utils';
import { useTranslation } from '../../hooks/useTranslation';

interface LocalizedDateProps {
  date: string;
  className?: string;
}

/**
 * Component to display a date in the user's preferred localized format
 * Uses interface language, not invoice language
 * 
 * @param date - Date in YYYY-MM-DD format
 * @param className - Optional CSS class name
 */
export const LocalizedDate: React.FC<LocalizedDateProps> = ({ date, className }) => {
  const { locale } = useTranslation(); // Use interface language
  
  if (!date) return null;
  
  return (
    <span className={className}>
      {toLocalizedFormat(date, locale)}
    </span>
  );
};

export default LocalizedDate; 